import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=418d2a44&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('418d2a44')) {
      api.createRecord('418d2a44', component.options)
    } else {
      api.reload('418d2a44', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=418d2a44&", function () {
      api.rerender('418d2a44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Gc08WG0ACP1A/JS/comp/ImgFallback.vue"
export default component.exports